import { 
  DC_LOAD_START,
  DC_LOAD_COMPLETE,
  DC_LOAD_ABORD,
  DC_LOAD_ERROR,
  DC_CANCEL
} from './../actions/actions_ajax'
import { 
  MEDIA_LOAD_START, 
  MEDIA_LOAD_COMPLETE,
  OFFCANVAS_SHOW,
  OFFCANVAS_HIDE
} from './../actions/actions_gui'

const initState = {
  loadingView: false,
  offcanvasShown: false,
  mediaQueue: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case DC_LOAD_START:
      return {...state, loadingView: true}
    case DC_LOAD_COMPLETE:
    case DC_LOAD_ABORD:
    case DC_LOAD_ERROR:
    case DC_CANCEL:
      return {...state, loadingView: false}
    case MEDIA_LOAD_START:
      return {...state, mediaQueue: [...state.mediaQueue.filter(id => id != action.payload ), action.payload]}
    case MEDIA_LOAD_COMPLETE:
      return {...state, mediaQueue: [...state.mediaQueue.filter(id => id != action.payload )]}
    case OFFCANVAS_SHOW:
      return {...state, offcanvasShown: true}
    case OFFCANVAS_HIDE:
      return {...state, offcanvasShown: false}
    default:
      return state
  }
}